var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:`${_vm.trailerId}-key`,class:`d-flex justify-center trailer__container ${_vm.wheelCssClasses}`,style:(`height: ${_vm.height};`),attrs:{"id":`${_vm.trailerId}-id`}},[_c('TrailerSVG',{ref:_vm.refererence,attrs:{"id":_vm.trailerId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }